import "./commonatoms.css";

const Seperator = ({ styles = {}, clsNames = "" }) => {
  return <div style={styles} className={clsNames}></div>;
};

export default Seperator;
// This component renders a simple separator line with customizable styles and class names.
// It can be used to visually separate sections in a user interface.
